const c = {
  name: "StarSky",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M7,0c0,3.9-3.1,7-7,7v2c3.9,0,7,3.1,7,7h2c0-3.9,3.1-7,7-7V7c-3.9,0-7-3.1-7-7H7z M11.9,8
			c-1.7,0.9-3,2.2-3.9,3.9c-0.9-1.7-2.2-3-3.9-3.9c1.7-0.9,3-2.2,3.9-3.9C8.9,5.8,10.2,7.1,11.9,8z"/>
		<path class="st0" d="M20,31v2c-3.9,0-7,3.1-7,7h-2c0-3.9-3.1-7-7-7v-2c3.9,0,7-3.1,7-7h2C13,27.9,16.1,31,20,31z M15.9,32
			c-1.7-0.9-3-2.2-3.9-3.9c-0.9,1.7-2.2,3-3.9,3.9c1.7,0.9,3,2.2,3.9,3.9C12.9,34.2,14.2,32.9,15.9,32z"/>
		<path class="st0" d="M28,7V2h-2v5c0,6.6-5.4,12-12,12v2c6.6,0,12,5.4,12,12v5h2v-5c0-6.6,5.4-12,12-12v-2C33.4,19,28,13.6,28,7z
			 M34.8,20c-3.5,1.4-6.4,4.2-7.8,7.8c-1.4-3.5-4.2-6.4-7.8-7.8c3.5-1.4,6.4-4.2,7.8-7.8C28.4,15.8,31.2,18.6,34.8,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as StarSky
};
